import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { storageKeys } from '../share/configs';

export interface AppConfig {
  externalOrderApiBaseUrl: string;
  a?: string;
  b?: string;
  c?: string;
  Default?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: AppConfig | null = null;

  constructor(private http: HttpClient) {}

  loadConfig(): Observable<AppConfig> {
    if (this.config) {
      return of(this.config);
    }

    return this.http.get<AppConfig>('/assets/config.json').pipe(
      tap((config) => {
        this.config = config;
      })
    );
  }

  getConfig(): AppConfig | null {
    return this.config;
  }

  getExternalOrderApiBaseUrl(): string {
    // First check if URL is stored in localStorage (set by 's' parameter)
    const storedUrl = localStorage.getItem(storageKeys.externalOrderApiBaseUrl);
    if (storedUrl) {
      return storedUrl;
    }

    // Fallback to config
    if (!this.config) {
      throw new Error('Config not loaded. Make sure APP_INITIALIZER has completed.');
    }
    return this.config.externalOrderApiBaseUrl || this.config.Default || '';
  }

  // Set API URL based on the 's' parameter from config
  setExternalOrderApiBaseUrlFromParam(paramValue: string): void {
    if (!this.config) {
      throw new Error('Config not loaded. Make sure APP_INITIALIZER has completed.');
    }

    // Get URL from config based on parameter value (e.g., 's=a' -> config.a)
    const url = (this.config as any)[paramValue] || this.config.Default;

    if (url) {
      localStorage.setItem(storageKeys.externalOrderApiBaseUrl, url);
    }
  }
}
